<div class="layout-auto-1">
	<div *ngIf="formularVersion?.data && formularVersion?.data.length === 0" class="splash empty">
		<p>{{getTranslation('Es wurden keine Formulare gefunden!')}}</p>
	</div>
	<div class="content"
	     *ngIf="formularVersion?.data && formularVersion?.data.length > 0">
		<exg-data-list #VCFormularList
		               selectKey="frmVID"
		               [displayState]="formularVersion?.data && formularVersion?.data.length > 0 ? 0 : 2"
		               [rowSource]="formularVersion.data">
			<ng-template #rowTemplate let-form>
				<div class="list-row list-row-auto-1-auto app-cursor-pointer"
				     (click)="onClickOpenFormularVersion(form)">
					<div></div>
					<div class="">
						<div class="list-primary-text">{{form.frmVName}}</div>
						<div class="list-secondary-text">{{form.frmVDescription}}</div>
					</div>
					<div class="list-metadata">
						<div class="typo-right">{{form.frmVCRD | excDate: 'dd.MM.yyyy HH:mm'}}</div>
						<div class="typo-right">{{form.frmVCRU}}</div>
					</div>
					<div></div>
					<div class="typo-left typo-small">
						{{enumSvc.getEnumerationText('FormularVersionStatus', form.frmV_enmIdent_FormularVersionStatus)}}
					</div>
					<div class="typo-right">
						<i [tooltip]="getGlobal('Edit')"
						   (click)="openModalFormularVersion($event, form)"
						   class="search-action fad fa-pen">
						</i>
						<i [tooltip]="getGlobal('Delete')"
						   (click)="deleteFormularVersionClick($event, form)"
						   class="search-action fad fa-trash">
						</i>
					</div>
				</div>
			</ng-template>
		</exg-data-list>
	</div>
</div>
